import { TransactionsFiltersForm } from 'features/onlinePayment/state/reports/transactions/types';

export function getTransactionsFiltersInitialData(): TransactionsFiltersForm {
  return {
    startDate: null,
    endDate: null,
  };
}
